<template>
  <comp_cabecero_imagen_evento :jornada="jornada"></comp_cabecero_imagen_evento>

  <div class="container-fluid jornada_ficha" v-if="loaded">
    <div class="row">
      <div class="col-12">
        <h1>{{ jornada.nombre_jornada }}</h1>

        <div class="row mt-5">
          <div
            class="texto_desarrollo col-12"
            :class="
              restaurantes.length === 0 && alojamientos.length === 0
                ? ''
                : 'col-lg-6'
            "
          >
            <div v-html="jornada.descripcion"></div>

            <div v-if="jornada.pdf" class="jornada_pdf">
              <a :href="jornada.pdf" target="_blank"  :style="{ '--jornada-color': jornada.color_jornada }">
                <i class="fa-solid fa-file-arrow-down fs-4"></i
                >{{ jornada.pdf_etiqueta }} 
              </a>
            </div>
          </div>

          <div
            v-if="restaurantes.length > 0 || alojamientos.length > 0"
            class="col-12 col-lg-6 mapa"
          >
            <comp_mapa_jornada />
          </div>
        </div>
      </div>
    </div>

    <!-- TODO PUEDE SER UN COMPONENTE? -->
    <div v-if="restaurantes.length < 1 && alojamientos.length < 1">
      <p class="uppercase fs-2 my-5 text-center" v-if="loaded">
        No hay participantes asignados en estos momentos
      </p>
    </div>

    <div class="container mt-5" v-if="loaded">
      <comp_lista_restaurantes
        v-if="jornada.restaurantes"
        :restaurantes="restaurantes"
        :nombre_seo_jornada="nombre_seo_jornada"
        :nombre_jornada="jornada.nombre"
        :color_jornada="jornada.color_jornada"
        :registros_pagina="jornada.registros_pagina"
      ></comp_lista_restaurantes>

      <comp_lista_alojamientos
        v-if="jornada.alojamientos"
        :alojamientos="alojamientos"
        :nombre_seo_jornada="nombre_seo_jornada"
        :nombre_jornada="jornada.nombre"
        :color_jornada="jornada.color_jornada"
        :registros_pagina="jornada.registros_pagina"
      ></comp_lista_alojamientos>
    </div>
  </div>

  <comp_banda_logos
    v-if="jornada.logos"
    :logosJornada="logos"
  ></comp_banda_logos>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { get_ficha_jornada } from "@/lib/peticiones_jornadas_api";
import comp_cabecero_imagen_evento from "../../components/tema_light/comp_cabecero_imagen_evento.vue";
import comp_banda_logos from "../../components/tema_light/comp_banda_logos.vue";
import comp_lista_restaurantes from "@/components/tema_light/comp_lista_restaurantes.vue";
import comp_lista_alojamientos from "@/components/tema_light/comp_lista_alojamientos.vue";
import comp_mapa_jornada from "@/components/tema_light/comp_mapa_jornada.vue";

const jornada = ref({});
const restaurantes = ref([]);
const alojamientos = ref([]);
const logos = ref([]);
const route = useRoute();
const idIdioma = ref("");
const { nombre_seo_jornada } = route.params;

const loaded = ref(false);

onMounted(async () => {
  let idIdiomaQuery = route.query.idIdioma || 0;
  let reload = route.query.reload || "";

  let idioma_seleccionado = localStorage.getItem("idioma_seleccionado");
  idIdioma.value = idioma_seleccionado === "es" ? 1 : 2;

  if ([1, 2].includes(idIdiomaQuery)) {
    idIdioma.value = idIdiomaQuery;
  }

  if (reload == 1) {
    sessionStorage.clear();
  }

  obtener_datos_ficha_jornada(idIdioma.value, nombre_seo_jornada);
});

watch(
  () => route.params.nombre_seo_jornada,
  (nuevo_nombre_seo_jornada) => {
    obtener_datos_ficha_jornada(idIdioma.value, nuevo_nombre_seo_jornada);
  }
);

const obtener_datos_ficha_jornada = async (idIdioma, nombre_seo_jornada) => {
  let respuesta = await get_ficha_jornada(idIdioma, nombre_seo_jornada);

  if (respuesta.result == "success") {
    loaded.value = true;
    let { data } = respuesta;

    jornada.value = data;
    document.title = "Escapada Asturias::" + data.nombre_jornada;

    if (jornada.value.restaurantes) {
      restaurantes.value = data.restaurantes;
      restaurantes.value.forEach((restaurante) => {
        restaurante.color_jornada = jornada.value.color_jornada;
      });
    }

    if (jornada.value.alojamientos) {
      alojamientos.value = data.alojamientos;
      alojamientos.value.forEach((alojamiento) => {
        alojamiento.color_jornada = jornada.value.color_jornada;
      });
    }
    if (jornada.value.logos) {
      logos.value = jornada.value.logos;
    }
  } else {
    console.log("Error en la peticion_obtener_datos_ficha_jornada", respuesta);
  }
};
</script>

<style lang="scss" scoped>
.mapa {
  min-height: 400px;
}

.jornada_ficha h1 {
  color: #000;
  font-size: clamp(1.375rem, 1.083rem + 1.46vw, 3rem);
  text-transform: uppercase;
  text-align: center;
}

.jornada_ficha .texto_desarrollo ul {
  list-style: none;
}

.jornada_ficha .texto_desarrollo ul li::before {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  content: "\f101";
  position: relative;
  margin-left: -25px;
  /* movemos icono a la izq */
  padding-right: 10px;
}

// :deep() se utiliza para aplicar estilos renderizados con v-html
.jornada_ficha .texto_desarrollo :deep(ul li) {
  margin-bottom: 10px;
}

.jornada_ficha .texto_desarrollo :deep(ul li b) {
  color: #000;
}


.jornada_ficha .texto_desarrollo :deep(a) {
  color: #000;
}
.jornada_ficha .texto_desarrollo :deep(a:hover) {
  font-weight: bolder;
}

.jornada_pdf {
  margin-top: 20px;
}
.jornada_pdf a > *:first-child {
  margin-right: 10px;
}
.jornada_pdf a:hover {
    color: var(--jornada-color);
}

/* Extra small devices (portrait phones, less than 576px)*/
@media (width <=575.98px) {
  .mapa {
    height: 50vh;
  }
}

/* Small devices (landscape phones, 576px and up)*/
@media (576px <=width <=767.98px) {
  .mapa {
    height: 50vh;
  }
}

/* Extra large devices xl(large desktops, 1400px and up)*/
@media (width >=1400px) {
  .jornada_ficha .texto_desarrollo {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>
